import _ from 'lodash'
import store from '../store'
import * as i18n from '@/setup/i18nSetup.js'

export function getGtmProducts() {
  const pricing = store.state.cart.calculatePriceResponse
  let products = []

  if (pricing.postage.length) {
    products = mapProductsWithPostage()
  } else {
    products = mapProductsWithoutPostage()
  }

  if (!products.length) {
    return []
  }

  let additionalServices = []

  if (pricing.additionalServices) {
    additionalServices = pricing.additionalServices.map(item => {
      return i18n.i18n.t(item.name)
    })

    additionalServices = additionalServices.join(',')
  }

  return products.map(product => {
    return {
      id: product.sku,
      name: product.name,
      price: product.price,
      variant: product.variant,
      category: 'create mail-outs',
      quantity: product.quantity,
      dimension8: product.zone || 'SE',
      dimension9: additionalServices
    }
  })
}

export function toDecimalPrice(price) {
  if (!_.isNumber(price)) return 0

  const decimal = price / 100
  return _.round(decimal, 2)
}

function mapProductsWithPostage() {
  const zonesMapping = {
    '0': 'SE',
    '1': 'EU',
    '2': 'Europe',
    '3': 'outside Europe'
  }

  const cart = store.state.cart
  const address = store.state.letter.address
  const pricing = cart.calculatePriceResponse
  const addressCount = address.numberOfRecipients
  const addressType = address.addressType
  const productDelivery = cart.productDelivery
  const baseProductName = i18n.i18n.t(pricing.baseProduct.name)
  const serviceCountry = 'SE'
  let priceWithoutPostage = pricing.baseProduct.priceWithVAT

  pricing.additionalServices.forEach(service => {
    //sum everything except postages
    priceWithoutPostage += service.priceWithVAT
  })

  return pricing.postage.map(postageProduct => {
    const zone =
      zonesMapping[postageProduct.zone] || postageProduct.zone || 'SE'
    const category = serviceCountry + ' ' + zone
    const postageName = i18n.i18n.t(postageProduct.name)
    const skuArray = [
      i18n.i18n.t(productDelivery.productName) +
        ' (' +
        productDelivery.productId +
        ')',
      'Service country ' + serviceCountry,
      postageName,
      'Postage zone ' + zone,
      'Address type ' + addressType
    ]

    pricing.additionalServices.forEach(service => {
      skuArray.push(i18n.i18n.t(service.name))
    })

    const price =
      _.round(priceWithoutPostage / addressCount, 0) +
      _.round(postageProduct.priceWithVAT / postageProduct.count, 0) //add a proportional slice of the priceWithoutPostage and the postage, divided by the count

    return {
      id: pricing.baseProduct.SAPproductId,
      name: baseProductName,
      sku: skuArray.join(','),
      price: toDecimalPrice(price),
      category: category,
      quantity: postageProduct.count,
      zone,
      variant: postageName
    }
  })
}

function mapProductsWithoutPostage() {
  const cart = store.state.cart
  const address = store.state.letter.address
  const pricing = cart.calculatePriceResponse
  const addressCount = address.numberOfRecipients
  const addressType = address.addressType
  const productDelivery = cart.productDelivery
  const baseProductName = i18n.i18n.t(pricing.baseProduct.name)
  const serviceCountry = 'SE'

  const category = serviceCountry + ' ' + 'SE' //admail is always sent to Sweden, doubtful it will change any time soon

  const skuArray = [
    i18n.i18n.t(productDelivery.productName) +
      ' (' +
      productDelivery.productId +
      ')',
    'Service country ' + serviceCountry,
    'Address type ' + addressType
  ]
  pricing.additionalServices.forEach(service => {
    skuArray.push(i18n.i18n.t(service.name))
  })

  let price = pricing.baseProduct.priceWithVAT
  pricing.additionalServices.forEach(service => {
    price += service.priceWithVAT
  })
  price /= addressCount //price per unit

  return [
    {
      id: pricing.baseProduct.SAPproductId,
      name: baseProductName,
      sku: skuArray.join(','),
      price: toDecimalPrice(price),
      category: category,
      quantity: addressCount,
      variant: baseProductName
    }
  ]
}
